// Aggregator pricing helpers — mirrors backend logic in create_order().

/**
 * Effective per-unit BASE price for a menu item at the given source.
 * Explicit swiggy_price / zomato_price wins. Otherwise falls back to
 * base_price * (1 + markup%) using Settings.
 * Returns a rounded (2dp) number.
 */
export function effectiveBasePrice(item, source, settings) {
  if (!item) return 0;
  if (source === "swiggy") {
    if (item.swiggy_price != null && item.swiggy_price !== "") {
      return +Number(item.swiggy_price).toFixed(2);
    }
    const m = Number(settings?.swiggy_markup_pct || 0);
    return +((item.base_price || 0) * (1 + m / 100)).toFixed(2);
  }
  if (source === "zomato") {
    if (item.zomato_price != null && item.zomato_price !== "") {
      return +Number(item.zomato_price).toFixed(2);
    }
    const m = Number(settings?.zomato_markup_pct || 0);
    return +((item.base_price || 0) * (1 + m / 100)).toFixed(2);
  }
  return +Number(item.base_price || 0).toFixed(2);
}

/**
 * Per-unit packaging charge for the source. Only applies to swiggy/zomato.
 */
export function packagingPerUnit(item, source) {
  if (!item) return 0;
  if (source === "swiggy") return Number(item.swiggy_packaging || 0);
  if (source === "zomato") return Number(item.zomato_packaging || 0);
  return 0;
}
